import { refreshIcons } from '../../base/utils.js';

export function openOffcanvas(url, title, size = 'lg', position = 'end') {
    const offcanvas = document.getElementById('universalOffcanvas');
    const titleEl = document.getElementById('offcanvasTitle');
    const body = document.getElementById('offcanvasBody');
    const backdrop = document.querySelector('.offcanvas-backdrop') || createOffcanvasBackdrop();

    if (!offcanvas) return;

    offcanvas.style.transition = 'none';
    offcanvas.classList.remove('show', 'offcanvas-start', 'offcanvas-end', 'offcanvas-top', 'offcanvas-bottom');
    const classes = offcanvas.className.split(' ').filter(c => !c.startsWith('offcanvas-'));
    offcanvas.className = classes.join(' ');
    offcanvas.classList.add('offcanvas');

    if (position === 'start') offcanvas.classList.add('offcanvas-start');
    else if (position === 'top') offcanvas.classList.add('offcanvas-top');
    else if (position === 'bottom') offcanvas.classList.add('offcanvas-bottom');
    else offcanvas.classList.add('offcanvas-end');

    if (size) offcanvas.classList.add(`offcanvas-${size}`);

    titleEl.innerText = title;
    body.innerHTML = `
        <div class="h-full w-full flex justify-center items-center">
            <i data-lucide="loader-2" class="w-8 h-8 animate-spin text-primary"></i>
        </div>
    `;
    refreshIcons();

    offcanvas.style.display = 'flex';
    backdrop.style.display = 'block';

    void offcanvas.offsetHeight;

    offcanvas.style.transition = '';

    requestAnimationFrame(() => {
        offcanvas.classList.add('show');
        backdrop.classList.add('show');
    });

    fetch(url)
        .then(response => {
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            return response.text();
        })
        .then(html => {
            body.innerHTML = html;
            refreshIcons();
            try {
                if (window.initComponents) window.initComponents();
            } catch (e) {
                console.error('Error initializing components in offcanvas:', e);
            }
        })
        .catch(err => {
            console.error('Offcanvas Fetch Error:', err);
            body.innerHTML = `<div class="p-3 text-error">Gagal memuat konten: ${err.message}</div>`;
        });
}

export function closeUniversalOffcanvas() {
    const offcanvas = document.getElementById('universalOffcanvas');
    const backdrop = document.querySelector('.offcanvas-backdrop');

    if (offcanvas) offcanvas.classList.remove('show');
    if (backdrop) backdrop.classList.remove('show');

    setTimeout(() => {
        const body = document.getElementById('offcanvasBody');
        if (body && !offcanvas.classList.contains('show')) {
            body.innerHTML = '';
            offcanvas.style.display = 'none';
            offcanvas.style.transition = 'none';
            backdrop.style.display = 'none';
        }
    }, 300);
}

function createOffcanvasBackdrop() {
    let backdrop = document.querySelector('.offcanvas-backdrop');
    if (!backdrop) {
        backdrop = document.createElement('div');
        backdrop.className = 'offcanvas-backdrop';
        document.body.appendChild(backdrop);
        backdrop.addEventListener('click', () => {
            closeAllOffcanvas();
        });
    }
    return backdrop;
}

function closeAllOffcanvas() {
    document.querySelectorAll('.offcanvas.show').forEach(el => el.classList.remove('show'));
    document.querySelectorAll('.offcanvas-backdrop.show').forEach(el => el.classList.remove('show'));
}

export function initOffcanvas() {
    document.querySelectorAll('[data-toggle="offcanvas"]').forEach(function (trigger) {
        if (trigger.dataset.initialized) return;
        trigger.dataset.initialized = 'true';

        trigger.addEventListener('click', function (e) {
            e.preventDefault();
            const target = document.querySelector(this.dataset.target);
            const backdrop = document.querySelector('.offcanvas-backdrop') || createOffcanvasBackdrop();

            if (target) {
                target.classList.add('show');
                backdrop.classList.add('show');
            }
        });
    });

    document.querySelectorAll('.offcanvas-close').forEach(function (el) {
        if (el.dataset.initialized) return;
        el.dataset.initialized = 'true';
        el.addEventListener('click', closeAllOffcanvas);
    });
}
